import DesignCode from "!!raw-loader!./iconbuttons/Design.tsx";
import DisabledCode from "!!raw-loader!./iconbuttons/Disabled.tsx";
import RoundCode from "!!raw-loader!./iconbuttons/Round.tsx";
import SizeCode from "!!raw-loader!./iconbuttons/Size.tsx";
import TooltipCode from "!!raw-loader!./iconbuttons/Tooltip.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Design from "./iconbuttons/Design";
import Disabled from "./iconbuttons/Disabled";
import Round from "./iconbuttons/Round";
import Size from "./iconbuttons/Size";
import Tooltip from "./iconbuttons/Tooltip";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Design", DesignCode, Design, "\"inactive\" buttons are useful in cases where sometimes the icon just acts as a read-only status indicator as opposed to a toggle to change status."),
		paneComponent("Disabled", DisabledCode, Disabled),
		paneComponent("Round", RoundCode, Round),
		paneComponent("Size", SizeCode, Size),
		paneComponent("Tooltip", TooltipCode, Tooltip),
	];

	return (
		<Pane
			components={components}
			imports='import {IconButton} from "designSystem/index";'
			muiApi="icon-button"
			muiComponent="buttons/#icon-buttons"
			{...props}
		/>
	);
};